/**
 * @description axios的封装
 */
import axios from 'axios';
// import qs from 'qs';
import { getEnv, getCookie } from './';
import { Modal } from 'antd';

axios.interceptors.request.use(function (config) {
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
    config.headers['Content-Type'] = 'application/json';
    config.headers['Accept'] = 'application/vnd.booking.v5+json';
    config.headers['Authentication'] = 'Basic ' + getCookie('Accesstoken');
    return Promise.resolve(config);
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    if (response.data.http_code === 200) {
        Modal.info({
            title: '登录信息已失效，请重新登录',
            okText: '确定',
            onOk() {
                window.location.href = `//${getEnv()}v.gaodun.com/member/login.html`;
            }
        });
    }
    return Promise.resolve(response);
}, function (error) {
    return Promise.reject(error);
});

export default class MarsAxios {

    constructor(options = {}) {
        this.options = options;
    }
    request(options) {
        return axios.request(options);
    }
    get(url, options = {}) {
        return this.request({
            method: 'get',
            url,
            baseURL: 'https://' + getEnv() + 'apigateway.gaodun.com',
            timeout: 1000 * 60, // 1分钟超时
            params: {
                ...options
            }
        });
    }
    post(url, data, options = {}) {
        // data = qs.stringify(data);
        return this.request({
            method: 'post',
            baseURL: 'https://' + getEnv() + 'apigateway.gaodun.com',
            timeout: 1000 * 60, // 1分钟超时
            url,
            data,
            ...options
        });
    }
}

const instanceAxios = new MarsAxios();
export const request = instanceAxios.request.bind(instanceAxios);
export const get = instanceAxios.get.bind(instanceAxios);
export const post = instanceAxios.post.bind(instanceAxios);
